var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flat-pickr',{staticClass:"form-control",attrs:{"config":_vm.config,"placeholder":_vm.I18n.t('helpers.select.prompt'),"name":_vm.name},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})}
var staticRenderFns = []

export { render, staticRenderFns }